import React, { Component } from "react";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4maps from "@amcharts/amcharts4/maps";
import am4geodata_worldLow from "@amcharts/amcharts4-geodata/worldLow";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import PropTypes from 'prop-types';

am4core.useTheme(am4themes_animated);

class MapChart extends Component {
	static propTypes = {
		id: PropTypes.string.isRequired,
		dataset: PropTypes.array.isRequired,
	};

	componentDidUpdate(prevProps) {
		if (prevProps.dataset !== this.props.dataset) {
			this.renderMaps(this.props.dataset);
		}
	}
	renderMaps() {
		const { id, dataset } = this.props;
		// TODO: Jika chart ini digunakan untukTOlong mapChart
		var chart = am4core.create(id, am4maps.MapChart);

		// atur definisi peta
		chart.geodata = am4geodata_worldLow;

		// atur proyeksi
		chart.projection = new am4maps.projections.Miller();

		// Buat seri Polygon Peta
		var polygonSeries = chart.series.push(new am4maps.MapPolygonSeries());

		// Buat Data Poligon Load (Like Names) dari Geojson
		polygonSeries.useGeodata = true;

		// Konfigurasikan seri
		var polygonTemplate = polygonSeries.mapPolygons.template;
		polygonTemplate.tooltipText = "{name}";
		polygonTemplate.polygon.fillOpacity = 0.6;

		// Buat keadaan hover dan atur warna pengisian alternatif
		var hs = polygonTemplate.states.create("hover");
		hs.properties.fill = chart.colors.getIndex(0);

		// tambahkan seri gambar
		var imageSeries = chart.series.push(new am4maps.MapImageSeries());
		imageSeries.mapImages.template.propertyFields.longitude = "longitude";
		imageSeries.mapImages.template.propertyFields.latitude = "latitude";
		imageSeries.mapImages.template.tooltipText = "{title}";
		imageSeries.mapImages.template.propertyFields.url = "url";

		var circle = imageSeries.mapImages.template.createChild(am4core.Circle);
		circle.radius = 3;
		circle.propertyFields.fill = "color";
		circle.nonScaling = true;

		var circle2 = imageSeries.mapImages.template.createChild(am4core.Circle);
		circle2.radius = 3;
		circle2.propertyFields.fill = "color";

		circle2.events.on("inited", function (event) {
			animateBullet(event.target);
		});

		function animateBullet(circle) {
			var animation = circle.animate(
				[
					{
						property: "scale",
						from: 1 / chart.zoomLevel,
						to: 5 / chart.zoomLevel,
					},
					{ property: "opacity", from: 1, to: 0 },
				],
				1000,
				am4core.ease.circleOut
			);
			animation.events.on("animationended", function (event) {
				animateBullet(event.target.object);
			});
		}

		var colorSet = new am4core.ColorSet();

		// Tampilkan Hanya INdonesia saya guys
		polygonSeries.include = ["ID"];

		// colorSEt.next() buat random colornya aja..
        // Bebarapa location salah, bisa cari list alamat (json) yang sesuai di google...
		let listProvinsi = []
		for (let i in dataset) {
			const item = dataset[i]
			const newData = new Object()
			newData.id = i
			newData.title = item.title
			newData.latitude = item.latitude
			newData.longitude = item.longitude
			newData.color = item.color
			listProvinsi.push(newData)
		}
		imageSeries.data = listProvinsi
	}

	componentWillUnmount() {
		if (this.chart) {
			this.chart.dispose();
		}
	}

	render() {
		const { id } = this.props;
		return <div id={id} style={{ width: "100%", height: "400px" }}></div>;
	}
}

export default MapChart;
